module.exports = __webpack_public_path__ + "img/logo.a1117fc6.svg";